import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4b578e88"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b578e88')) {
      api.createRecord('4b578e88', component.options)
    } else {
      api.reload('4b578e88', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=4b578e88", function () {
      api.rerender('4b578e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Footer.vue"
export default component.exports